import { FormattedSKU } from './useSKUs'
import { Brand as BrandType } from '../types/brand'
import useBrand from './useBrand'
import usePageProduct from './usePageProduct'
import useDiscountToken from './useDiscountToken'
import { useMemo } from 'react'

export interface HandlebarsPropType {
  brand: Partial<BrandType>
  pageSKU: Partial<FormattedSKU | undefined>
  discountToken: string | null
}

// TODO - Work in Progress. I need to figure out what is the correct information to add in the handlebar context
export default function useHandlebarsContext(): HandlebarsPropType {
  const brand = useBrand()
  const pageSKU = usePageProduct()
  const discountToken = useDiscountToken()
  const handlebarsProp = useMemo(
    () => ({ brand, pageSKU, discountToken }),
    [brand, pageSKU, discountToken]
  )
  return handlebarsProp
}
